import type {
  ColumnInputOptions,
  ColumnRuleWithMetadata,
  DropdownInputOptions,
  NumberInputOptions,
  ParameterWithMetadata,
  TextInputOptions,
} from '@/tableDefinitionEditor/columnRules/columnRuleBuilder.types';
import type { ColumnRule } from '@/tableDefinitionEditor/columnRules/columnRule.constants';
import { ColumnRulesWithMetaData } from '@/tableDefinitionEditor/columnRules/columnRuleBuilder.constants';

export function isDropdownInputOptions(input: any): input is DropdownInputOptions {
  return input.type === 'optionDropdown';
}

export function isTextInputOptions(input: any): input is TextInputOptions {
  return input.type === 'text';
}

export function isColumnInputOptions(input: any): input is ColumnInputOptions {
  return input.type === 'columnDropdown';
}

export function isNumberOptions(input: any): input is NumberInputOptions {
  return input.type === 'number';
}

export function getColumnRuleWithMetaData(rule: ColumnRule): ColumnRuleWithMetadata | undefined {
  return ColumnRulesWithMetaData.find((columnRule) => columnRule.rule === rule);
}

export function getParameterWithMetadataFromColumnRule(
  rule: ColumnRuleWithMetadata,
  parameter: string,
): ParameterWithMetadata | undefined {
  return rule.allParameters.find((param) => param.parameter === parameter);
}

export const openTooltipLink = () =>
  window.open('https://telemetry.seeq.com/support-link/kb/latest/cloud/applying-column-rules');
